module.exports = __webpack_public_path__ + "static/20180720_115409_optimized-df7f040b16627d915259fa7f4e71a2bc.jpg";